import AppRegularLink from './AppRegularLink.vue';

export default AppRegularLink;



// WEBPACK FOOTER //
// ./src/uikit/links/AppRegularLink/index.ts